export default "__VITE_ASSET__30814de8__"